import React from "react";
import {faFingerprint, faLink} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {NavLink} from "react-router-dom";
import {BASE_PATH} from "../../../../../wpconfig";

const JBasic = (parent) => {
	// console.log(parent)
	const record = parent.record;
	// const record = this.props.record;
	//
	return (
		<div className="journal-detail-basic">
			<div className="document-list-item">
				<h2 className="hide only-print text-center mt-2 mb-5">PNU Scholar Journal Information</h2>
				<div className="hide xonly-print text-right">Printed Date 2021-11-02 hh-mm-ss</div>

				<div className="item-subject big">{record.journal_title}
					{rmVars.isEditor &&
					<a href={rmVars.homeUrl + "?page=journal&record_id=" + record.journal_id}
						target="_blank"
					   className="ml-2"><span className="editor-edit"></span></a>
					}
				</div>
				<div className="item-info mt-2">
					<div className="info-cell">
						{record.issn ? (
							<>
								<strong>ISSN</strong> {record.issn}
							</>
						) : null}

						{record.issn && record.eissn ? " | " : null}

						{record.eissn ? (
							<>
								<strong>E-ISSN</strong> {record.eissn}
							</>
						) : null}
					</div>
					<div className="info-cell"><strong>Publisher</strong> {record.publisher}</div>
				</div>
				<div className="item-options mt-2 d-flex">
					<div className="options-cell">
						<div className="badge-group">
							<div className="badge-group-inner">
							{record.journal_ranking && record.journal_ranking.map((item, num) => {
									let className = 'badge bg-lightpurple rounded-0';
									if (!item.percent || !item.indicator_type)
										return;
									item.name = item.indicator_type
									// item.name = item.indicator_type.toUpperCase()
									if (item.name.includes('KCI'))
										className = 'badge bg-lightgreen rounded-0';
									else if (item.name.includes('Scopus'))
										className = 'badge bg-lightorange rounded-0';
									return (
										<div key={num} className={className}>{item.name} {item.year} (Top {item.percent}%)</div>
									)
								})}
								{record.registered_db && record.registered_db.map((item, num) => {
									let className = 'badge bg-lightpurple';
									if (!item.name)
										return;
									// item.name = item.name.toUpperCase()
									if (item.name.includes('KCI'))
										className = 'badge bg-lightgreen';
									else if (item.name.includes('Scopus'))
										className = 'badge bg-lightorange';
									else if (item.name.includes('Nature Index'))
										className = 'badge bg-skyblue';
									return (
										<div key={num} className={className}>{item.name}</div>
									)
								})}
							</div>
						</div>
					</div>
					<div className="options-cell">
						{record.resource_count &&
						<NavLink to={BASE_PATH + "resources/?journal_id[]=" + record.journal_id}
								 className="color-lightblack">PNU Articles ({record.resource_count})</NavLink>
						}
					</div>
					<div className="ml-auto">
						<span style={{cursor:"pointer", display : 'block'}} onClick={() => window.print()}>
							<span className="print-icon"> </span>
							<span className="position-relative text-muted" style={{top:-9}}>Print</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default JBasic;
